import $ from 'jquery';

/**
 * Часто используемые jQuery элементы
 */
const libNodes = {
    $html: $('html'),
    $htmlBody: $('html, body'),
    $main: $('main')
};

export default libNodes;
